import styled from 'styled-components';
import { IonModal } from '@ionic/react';

export const IonModalWrapper = styled(IonModal)`
  .date-label {
    font-weight: bold;
  }
  
  .comment {
    white-space: normal;
  }
`;
